import { apiPlugin, storyblokInit } from "@storyblok/react/rsc";
import Accordion from "@/components/bloks/Accordion";
import ContactForm from "@/components/bloks/ContactForm";
import Copy from "@/components/bloks/Copy";
import Links from "@/components/bloks/Links/index";
import LogoCloud from "@/components/bloks/LogoCloud";
import Timeline from "@/components/bloks/Timeline";
import TimelineSteps from "@/components/elements/TimelineSteps";
import Page from "@/components/entities/Page";
import { env } from "@/env";

export const getStoryblokApi = storyblokInit({
  bridge: env.NEXT_PUBLIC_STORYBLOK_PREVIEW === "true",
  accessToken: env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  components: {
    // Entities
    page: Page,
    // Bloks
    logoCloud: LogoCloud,
    copy: Copy,
    links: Links,
    accordion: Accordion,
    timeline: Timeline,
    contactForm: ContactForm,
    // Elements
    timelineSteps: TimelineSteps,
  },
  apiOptions: {
    region: "eu",
  },
});
